function validCourier( shop_id = false , courier_id = false , tracking ) {
    
    let shop =  {
                "2": {
                    "15": {
                        "format" : /^R[A-Z]{1}[0-9]{9}TH$/g
                    },
                    "45": {
                        "format" : /^P[A-Z]{1}[0-9]{9}TH$/g
                    }
                },
    }

    if(shop[shop_id] === undefined || shop[shop_id][courier_id] === undefined){
        return "No Shop";
    }else{
        let regex = shop[shop_id][courier_id]['format']
        return regex.test(tracking);
    }   
}
export default validCourier